<template>
  <b-input-group>
    <b-row no-gutters>
      <b-col cols="3">
        <b-form-select
          id="country"
          v-model="countryCode"
          v-validate="'required'"
          :options="countryCodes"
          required
        />
      </b-col>
      <b-col cols="7">
        <b-form-input
          v-if="phoneNumberInfo"
          ref="basicInputTextField"
          v-model="phoneNumberInfo.nationalNumber"
          name="numéro de téléphone"
          autocomplete="adv-telephone"
          @keyup.native="onTextChange"
          @keypress="isNumber"
        />
      </b-col>
      <b-col cols="2">
        <b-input-group-append>
          <b-button @click="showModal">
            {{ $t("my-profile-information-validate-phone-button") }}
          </b-button>
        </b-input-group-append>
      </b-col>
    </b-row>
    <b-row v-if="!isValid">
      <b-col>
        <div
          style="
            margin-left: 10px;
            margin-right: 10px;
            color: red;
            text-alignment: center;
            text-wrap: true;
          "
        >
          {{ errorMessage }}
        </div>
      </b-col>
    </b-row>
  </b-input-group>
</template>
<script>
import {
  parsePhoneNumberFromString,
  getCountries,
  getCountryCallingCode,
  isSupportedCountry,
  findPhoneNumbersInText,
} from "libphonenumber-js";
const approvedCodes = ["FR", "RU", "VN", "AUS", "US"];
export default {
  props: {
    value: {
      type: String,
      required: false,
      default: undefined
    },
    label: {
      type: String,
      required: false,
      default: undefined,
    },
    hint: {
      type: String,
      required: false,
      default: "",
    },
    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
    errorRequiredMessage: {
      type: String,
      required: true,
    },
    errorInvalidMessage: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    validatePhone: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isValid: true,
      errorMessage: undefined,
      countryCodes: [],
      countryCode: approvedCodes[0],
      phoneNumberInfo: {
        nationalNumber: null,
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function (value) {
        if(!value) return
        const result = findPhoneNumbersInText(value);
        if (!result || result.length === 0) return;
        this.phoneNumberInfo = result[0].number;
        this.countryCode = result[0].number.country;
      },
    },
    countryCode() {
      this.onTextChange();
    },
  },
  created() {
    this.getCountryCode();
  },
  methods: {
    onTextChange() {
      const value = this.$refs.basicInputTextField.value;
      this.validate("+" + getCountryCallingCode(this.countryCode) + value);
      this.$emit(
        "input",
        "+" + getCountryCallingCode(this.countryCode) + value
      );
    },
    validate(text) {
      this.isValid = true;
      if (this.required) {
        this.isValid =
          this.isValid && Boolean(this.$refs.basicInputTextField.value);
        this.errorMessage = this.errorRequiredMessage;
      }
      // check valid phone if text is not blank
      if (
        this.isValid &&
        Boolean(this.$refs.basicInputTextField.value) &&
        this.validatePhone
      ) {
        const phoneNumber = parsePhoneNumberFromString(text, this.countryCode);
        this.isValid = phoneNumber && phoneNumber.isValid();
        this.errorMessage = this.errorInvalidMessage;
      }
      this.$emit("validate", this.isValid);
      return this.isValid;
    },
    getCountryCode() {
      const countries = getCountries();
      const countryWithCode = countries
        .filter((country) => approvedCodes.includes(country))
        .map(function (country) {
          if (!isSupportedCountry(country)) return;
          const callingCode = getCountryCallingCode(country);
          return {
            value: country,
            text: `+${callingCode} (${country})`,
          };
        });
      this.countryCodes = countryWithCode;
    },
    showModal() {
      this.$emit("showModal");
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
